import React from "react";
import { Container, Row, Col, Accordion } from "react-bootstrap";
import HeaderNavbar from "./Navbar";
import Footer from "./Footer";

export default function FAQ() {
  const faqs = [
    {
      question: "How do I create an account?",
      answer:
        "Simply sign up using your mobile number or email address, verify your OTP and complete your profile with accurate personal information.",
    },
    {
      question: "Is registration free?",
      answer:
        "Yes. Registration is completely free. However, certain premium features are available through our paid membership plans.",
    },
    {
      question: "Why should I verify my profile?",
      answer:
        "A verified profile increases trust and improves your chances of receiving genuine match requests.",
    },
    {
      question: "How can I verify my identity?",
      answer:
        "You can complete Aadhaar verification from your account settings. Verified profiles receive a verification badge.",
    },
    {
      question: "Is my personal information secure?",
      answer:
        "Yes. We use industry-standard security measures to protect your personal information. Your data is handled according to our Privacy Policy.",
    },
    {
      question: "Can I edit my profile after registration?",
      answer:
        "Yes. You can update your profile, education, profession, family details, partner preferences and photos at any time.",
    },
    {
      question: "How do I upload profile photos?",
      answer:
        "Go to your profile, open the Photos section and upload clear, recent photographs that follow our photo guidelines.",
    },
    {
      question: "Why was my profile or photo rejected?",
      answer:
        "Profiles or photos may be rejected if they contain inappropriate content, misleading information, copyrighted images or violate our community guidelines.",
    },
    {
      question: "How are matches suggested?",
      answer:
        "Matches are recommended based on your profile details, partner preferences, age, religion, caste, education, profession and location.",
    },
    {
      question: "Can I search for members myself?",
      answer:
        "Yes. Our advanced search allows you to filter members by age, religion, caste, education, profession, location and more.",
    },
    {
      question: "Can I send interest to another member?",
      answer:
        "Yes. You can send an interest request to other members. Once accepted, you may communicate depending on your membership plan.",
    },
    {
      question: "What are the benefits of Premium Membership?",
      answer:
        "Premium members enjoy unlimited profile views, contact details access, unlimited interests, priority visibility and advanced search features.",
    },
    {
      question: "Are membership fees refundable?",
      answer:
        "Membership fees are generally non-refundable unless otherwise required by applicable law or mentioned in our Refund Policy.",
    },
    {
      question: "How do I report a fake profile?",
      answer:
        "Open the member's profile and click the 'Report Profile' option. Our moderation team will review the report promptly.",
    },
    {
      question: "How can I block someone?",
      answer:
        "You can block any member directly from their profile page. Blocked members won't be able to contact you.",
    },
    {
      question: "What should I do if someone behaves inappropriately?",
      answer:
        "Immediately report the member through the reporting feature and avoid sharing personal or financial information.",
    },
    {
      question: "Which payment methods are accepted?",
      answer:
        "We accept UPI, Debit Cards, Credit Cards, Net Banking and other secure online payment methods supported by our payment gateway.",
    },
    {
      question: "Is online payment secure?",
      answer:
        "Yes. All transactions are processed through secure and encrypted payment gateways to ensure your payment information remains protected.",
    },
    {
      question: "How do I reset my password?",
      answer:
        "Click the 'Forgot Password' option on the login page and follow the OTP verification process to create a new password.",
    },
    {
      question: "Can I deactivate or delete my account?",
      answer:
        "Yes. You can deactivate or permanently delete your account from your account settings. Account deletion is irreversible.",
    },
    {
      question: "How can I contact customer support?",
      answer:
        "You can contact our support team through the Contact Us page, email or customer care number available on our website.",
    },
  ];

  return (
    <>
      <HeaderNavbar />

      {/* PAGE HEADER */}
      <div
        style={{
          background: "#f8f5f2",
          padding: "60px 0",
          textAlign: "center",
        }}
      >
        <h1 style={{ color: "#7b1e3b", fontWeight: "600" }}>
          Frequently Asked Questions
        </h1>
        <p className="text-muted mt-3">
          Find answers to the most commonly asked questions.
        </p>
      </div>

      {/* FAQ SECTION */}
      <Container style={{ padding: "70px 0" }}>
        <Row className="justify-content-center">
          <Col lg={10}>
            <Accordion alwaysOpen>
              {faqs.map((faq, index) => (
                <Accordion.Item
                  eventKey={index.toString()}
                  key={index}
                  className="mb-3 border rounded shadow-sm"
                >
                  <Accordion.Header>
                    <strong>{faq.question}</strong>
                  </Accordion.Header>
                  <Accordion.Body>{faq.answer}</Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Col>
        </Row>
      </Container>

      <Footer />
    </>
  );
}